<template>
  <div class="modal" :class="{ active: showModal }">
    <div
      class="modal-background"
      @click="close"
      :class="{ active: showModal }"
    ></div>
    <div class="modal-contnent" :class="{ active: showModal }">
      <div class="calc-height">
        <div class="modal-heading">
          <h3 class="font-24 tbc-bold">{{ $fn.tr("Data preferences") }}</h3>
          <svg
            class="close"
            @click="close"
            xmlns="http://www.w3.org/2000/svg"
            width="25.456"
            height="25.456"
          >
            <path
              data-name="Combined Shape"
              d="M6.364 17.678l4.95-4.95-4.95-4.95a1 1 0 111.414-1.414l4.95 4.95 4.95-4.95a1 1 0 111.414 1.414l-4.95 4.95 4.95 4.95a1 1 0 01-1.414 1.414l-4.95-4.95-4.95 4.95a1 1 0 01-1.414-1.414z"
              fill="#dadada"
            />
          </svg>
        </div>

        <div class="preferences-list">
          <p class="font-13 tbc-regular lh-20 mb34">
            {{ $fn.tr("The types of cookies used on this website") }}
          </p>
          <template v-for="(item, index) in data">
            <div class="preference-item" :key="index">
              <div class="flex justify-between heading">
                <h4 class="font-16 tbc-bold lh-30">{{ $fn.tr(item.title) }}</h4>
                <Toggler
                  :status="item.toggle"
                  :class="{ 'not-allowed': item.toggle }"
                />
              </div>
              <p class="font-13 tbc-regular lh-20">
                {{ $fn.tr(item.content) }}
              </p>
            </div>
          </template>
        </div>
      </div>

      <button
        class="font-16 tbc-bold lh-30 br-6"
        @click="$emit('acceptCookie')"
      >
        {{ $fn.tr("Save") }}
      </button>
    </div>
  </div>
</template>
<script>
import Toggler from "../Toggler";

export default {
  props: ["showModal"],
  components: {
    Toggler
  },
  data() {
    return {
      something: true,
      data: [
        {
          id: 1,
          title: "Strictly necessary",
          toggle: true,
          content: `strict_necessary_cookies_text`
        },
        {
          id: 2,
          title: "Performance",
          toggle: false,
          content: `performance_cookies_text`
        },
        {
          id: 3,
          title: "Targeting",
          toggle: false,
          content: `targeting_cookies_text`
        },
        {
          id: 4,
          title: "Functionality & Profile",
          toggle: false,
          content: `functionality_cookies_text`
        }
      ]
    };
  },
  created() {},
  watch: {
    showModal: {
      immediate: true,

      handler(val) {
        if (val) {
          document.querySelector("html").style.overflow = "hidden";
          document.querySelector("body").style.marginRight = "10px";
        } else {
          document.querySelector("html").style.overflow = "auto";
          document.querySelector("body").style.marginRight = "0px";
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit("closeModal", false);
    }
  },
  mounted() {
    let self = this;

    document.addEventListener("keyup", function(event) {
      // If  ESC key was pressed...
      if (event.keyCode === 27) {
        // try close your dialog
        self.close();
      }
    });
  }
};
</script>

<style scoped>
.mb21 {
  margin-bottom: 21px;
}
.mb30 {
  margin-bottom: 30px;
}
.mb34 {
  margin-bottom: 34px;
}
.mb40 {
  margin-bottom: 40px;
}
.relative {
  position: relative;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.calc-height {
  height: calc(100% - 60px);
  overflow: hidden;
}
.preference-item {
  margin-bottom: 34px;
}
.heading {
  margin-bottom: 20px;
}
.modal {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.modal.active {
  pointer-events: unset;
}
.modal-background {
  opacity: 0;
  transition: 0.4s;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgb(1, 4, 7, 0.6);
}
.modal-background.active {
  opacity: 1;
  transition: 0.2s;
  visibility: visible;
}

.modal-contnent {
  position: fixed;
  width: 496px;
  transform: translateX(1000px);
  padding: 45px 50px 50px;
  right: 0;
  top: 0;
  background: #364756;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  transition: 0.4s;
}
.modal-contnent.active {
  transform: translateX(0px);
  transition: 0.4s;
}
.modal-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 36px;
}
.modal-heading h3 {
  color: #dadada;
  line-height: 30px;
}
.preferences-list {
  height: 85%;
  overflow-y: scroll;
  padding-right: 50px;
  margin-right: -47px;
}
.preferences-list::-webkit-scrollbar {
  width: 8px;
  background: none;
}
.preferences-list::-webkit-scrollbar-thumb {
  background: var(--tbc-blue);
  width: 8px;
  border-radius: 6px;
}
h4 {
  color: #dadada;
}
.preferences-list p {
  color: #dadada;
  font-size: 16px;
}
.modal-contnent button {
  background: #2a3946;
  color: #fff;
  text-align: center;
  width: 100%;
  height: 60px;
}
.not-allowed {
  cursor: not-allowed;
  opacity: 0.6;
}
.close {
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .modal-contnent {
    width: 100%;
    padding: 30px;
  }
  .modal-heading h3 {
    font-size: 16px;
    line-height: 24px;
  }
  .modal-heading {
    margin-bottom: 21px;
  }
  .heading {
    margin-bottom: 16px;
  }
  .calc-height {
    height: calc(100vh - 150px);
    margin-bottom: 30px;
  }
  .modal-contnent {
    /* justify-content: inherit; */
  }
  .preferences-list {
    height: calc(100% - 30px);
  }
  .preference-item {
    margin-bottom: 21px;
  }
}
</style>
